var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-navigation'),_c('v-main',{staticClass:"light-grey"},[_c('router-view'),_c('error-message')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }